/* si-collection-header.js
 * Owns the client-side filter state for the collection page:
 *   - search input (#collectionSearchInput) — title contains
 *   - filter pills (.si-pill) — product tags AND-match
 *
 * Each <li.grid__item> must carry:
 *   data-title="<product title>"
 *   data-tags="<lowercase, pipe-joined tag list>"
 *
 * Sets window.siCollectionHeaderActive=true so the legacy inline
 * search handler in main-collection-product-grid.liquid can stand
 * down (it gates on this flag).
 */
(function () {
  'use strict';

  window.siCollectionHeaderActive = true;

  function init() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const items = Array.from(grid.querySelectorAll('.grid__item'));
    if (!items.length) return;

    const searchInput = document.getElementById('collectionSearchInput');
    const pills = Array.from(document.querySelectorAll('.si-pill[data-si-filter-tag]'));

    const state = {
      q: '',
      tags: new Set(), // active tag filters, lowercase
    };

    function apply() {
      const q = state.q.trim().toLowerCase();
      const tags = state.tags;

      for (const li of items) {
        let show = true;

        if (q) {
          const title = (li.getAttribute('data-title') || '').toLowerCase();
          if (!title.includes(q)) show = false;
        }

        if (show && tags.size > 0) {
          const raw = (li.getAttribute('data-tags') || '').toLowerCase();
          // raw is "tag1|tag2|tag3"; require ALL active tags to be present
          const have = new Set(raw.split('|').filter(Boolean));
          for (const t of tags) {
            if (!have.has(t)) { show = false; break; }
          }
        }

        li.classList.toggle('si-hidden', !show);
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.q = this.value || '';
        apply();
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        const tag = (pill.getAttribute('data-si-filter-tag') || '').toLowerCase();
        if (!tag) return;
        const pressed = pill.getAttribute('aria-pressed') === 'true';
        if (pressed) {
          state.tags.delete(tag);
          pill.setAttribute('aria-pressed', 'false');
        } else {
          state.tags.add(tag);
          pill.setAttribute('aria-pressed', 'true');
        }
        apply();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
